
import { schema } from "./types";
import { IAutomationAppComponent, IAutomationObject } from "../../../types";
import { OverviewPanel, OperatorPanel } from './';
import { SlLayers } from 'react-icons/sl';
import { schema as schemaFloor } from '../P_Floor/types'
import { schema as schemaRoom } from '../../../SubPlants/SP_Room/types'
import { ParameterPanel } from "./ParameterPanel";

export const App: IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: SlLayers,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ParameterPanel: ParameterPanel,
    createConfig: {
        group: "Spaces",
        name: "Floors and rooms",
        description: 'Room Automation',
        panel: OverviewPanel,
    },
    addAppFilter: (app: IAutomationObject) => app.schema === schemaFloor || app.schema === schemaRoom
}
